import type { IDocument } from "@bbj-types/document";
import { Autocomplete, Stack, TextField } from "@mui/material";
import type { Dispatch, SetStateAction } from "react";

interface IMailTemplateProps {
  template: IDocument | null;
  setTemplate: Dispatch<SetStateAction<IDocument | null>>;
  getMailTemplates: () => IDocument[];
}

export const MailTemplate = ({ template, setTemplate, getMailTemplates }: IMailTemplateProps) => {
  const mailTemplates = getMailTemplates();

  return (
    <Stack
      sx={{
        gap: 2,
      }}
    >
      <Autocomplete
        renderInput={(params) => <TextField {...params} size="small" label="Courrier type *" />}
        value={template}
        options={mailTemplates}
        onChange={(_, value) => setTemplate(value)}
        getOptionLabel={(option) => option.name.split(".")[0]}
        sx={{ width: "280px" }}
      />
    </Stack>
  );
};
